<template>
  <section class="events-carousel">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <h1 class="events-title">
            {{$t("events.recents")}}
          </h1>
        </div>
        <div class="col-sm-2 col-6 d-md-block"
          v-for="event in events"
          :key="event.id">
          <router-link v-if="!event.external"
            :to="{name: 'ShowEvent', params: {id: event.identifier.toString()}}">
            <img :src="event.logo_url" class="img-fluid" />
          </router-link>
          <a v-if="event.external" 
            :href="event.external_url" >
            <img :src="event.logo_url" class="img-fluid" />
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import EventList from "../../models/EventList"

export default {
  name: "CarrouselRecentEvents",
  data() {
    return {
      events: [],
      eventList: new EventList()
    }
  },
  async created() {
    this.events = await this.eventList.recents({});
  }
}
</script>

<style scoped>
  .events-carousel {
    background: #dddddd;
    width: 100%;
    margin-top: 30px;
    padding: 40px 40px 40px 40px;
  }
  .events-title {
    font-style: normal;
    font-weight: bold;
    font-size: 40px;
    line-height: 60px;
    text-align: center;
  }
  @media (max-width: 767px) {
    .events-title {
      font-size: 30px;
      line-height: 30px;
    }
  }
</style>
